import { contentTypeServices } from '../services/contentTypeServices';

import { ContentTypeAction } from '../types/ContentTypeAction';
import ContentTypeData from '../types/ContentTypeData';

const contentTypeList = () => (dispatch: any) => {
  const success = (data: ContentTypeData[]): ContentTypeAction =>
    ({ type: 'CONTENT_TYPE_SUCCESS', data });
  const failure = (error: string): ContentTypeAction =>
    ({ type: 'CONTENT_TYPE_FAILED', error });

  contentTypeServices.list()
    .then(
      res => { dispatch(success(res)) },
      err => { dispatch(failure(err)) }
    );
}

export {
  contentTypeList,
};

const contentTypeActions = {
  list: contentTypeList,
};

export default contentTypeActions;